import {
    UPDATE_LOC_SELECT,
    UPDATE_USER_POSITION,
    UPDATE_USER_POINT,
} from '../actions/ActionTypes';

const initialState = {
    locSelect: [0, 0, 0],
    curMultiArray: [[], [], []],
    userPosition: {},
    latitude: '',
    longitude: ''
};
export function locationPageReducer(state = initialState, action) {
    switch (action.type) {
        case UPDATE_LOC_SELECT:
            return {
                ...state,
                locSelect: action.data
            };
        case UPDATE_USER_POSITION:
            return {
                ...state,
                userPosition: action.data.userPosition,
            };
        case UPDATE_USER_POINT:
            return {
                ...state,
                latitude: action.data.latitude,
                longitude: action.data.longitude
            };
        default:
            return state;
    }
}
